import React from 'react';
import { useTranslation } from 'react-i18next';

const formatBrand = (brand) => {
    if (!brand) return '';
    const map = { visa: 'Visa', mastercard: 'Mastercard', amex: 'American Express', sepa_debit: 'SEPA' };
    return map[brand.toLowerCase()] || brand.toUpperCase();
};

const StripeCard = ({ type, brand, last4, exp_month, exp_year }) => {
    const { t } = useTranslation();
    const isSepa = type === 'sepa_debit';

    return (
        <div style={{
            background: '#fff',
            border: '1px solid #dee2e6',
            borderRadius: '8px',
            padding: '16px',
            maxWidth: '480px',
            width: '100%',
            textAlign: 'left',
        }}>
            <div style={{ fontSize: '1.4em', marginBottom: '8px' }}>{isSepa ? '🏦' : '💳'}</div>
            <div style={{ fontWeight: 600, fontSize: '1em' }}>
                {formatBrand(brand || type)} •••• {last4}
            </div>
            {!isSepa && exp_month && (
                <div style={{ fontSize: '0.85em', color: '#6c757d', marginTop: '4px' }}>
                    {t('payment.expires') || 'Expire'} {String(exp_month).padStart(2, '0')}/{exp_year}
                </div>
            )}
        </div>
    );
};

export default StripeCard;
